module.exports = __webpack_public_path__ + "static/media/ship-station-branding.d1756e30.png";